module.exports = __webpack_public_path__ + "img/look4.0c4e0dd2.png";